module.exports = __webpack_public_path__ + "img/7.240dee7e.jpg";